import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_POINTS_COULD_DIFFERENT_DATA = "paginationPointsCouldDifferentData";
export const LIST_POINTS_COULD_DIFFERENT_DATA = "listPointsCouldDifferentData";
export const GET_POINTS_COULD_DIFFERENT_DATA = "getPointsCouldDifferentData";
export const POST_POINTS_COULD_DIFFERENT_DATA = "postPointsCouldDifferentData";
export const PUT_POINTS_COULD_DIFFERENT_DATA = "putPointsCouldDifferentData";
export const PUT_POINTS_COULD_DIFFERENT_STATUS_DATA = "putPointsCouldDifferentStatusData";
export const DELETE_POINTS_COULD_DIFFERENT_DATA = "deletePointsCouldDifferentData";
// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";
export const SET_STATE_PRAM_POINTS_COULD_DIFFERENT = "setStarePramPointsDifferentCould";


export default {
  state: {
    path: "points_could_different",   
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "id",
      isDesc: true,
      sortDirection: "asc",
      filter: "",
      data_pram:''
    }
  },
  getters: {},
  actions: {
    [PAGINATION_POINTS_COULD_DIFFERENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [LIST_POINTS_COULD_DIFFERENT_DATA](context) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}`);
    },
    [GET_POINTS_COULD_DIFFERENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/${payload.id}`);
    },
    [POST_POINTS_COULD_DIFFERENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload.data);
    },
    [PUT_POINTS_COULD_DIFFERENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/${payload.id}`,
        payload.data
      );
    },
    [PUT_POINTS_COULD_DIFFERENT_STATUS_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.put(
        `${context.state.path}/status/${payload.id}`,
        payload.data
      );
    },
    [DELETE_POINTS_COULD_DIFFERENT_DATA](context, payload) {
      ApiService.setHeader();
      return ApiService.delete(`${context.state.path}/${payload.id}`);
    }
  },
  mutations: {
    [SET_STATE_PRAM_POINTS_COULD_DIFFERENT](state, payload) {
      state.data_pram = payload;
    },
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "id",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};
